import {
  LISTEN_TO_CURRENT_USER_ACCOUNT,
  REQUEST_ACCOUNT_DELETE,
} from "./accountConstants";
import { SIGN_OUT_USER } from "../auth/authConstants";

const initialState = {
  currentUserAccount: null,
  deleteAccountDetails: null,
};

export function requestAccountDeleteAction(account) {
  return {
    type: REQUEST_ACCOUNT_DELETE,
    payload: account,
  };
}

export default function accountReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case LISTEN_TO_CURRENT_USER_ACCOUNT:
      return {
        ...state,
        currentUserAccount: payload,
      };
    case SIGN_OUT_USER:
      return {
        currentUserAccount: null,
        deleteAccountDetails: null,
      };
    case REQUEST_ACCOUNT_DELETE:
      return {
        ...state,
        deleteAccountDetails: payload,
      };
    default:
      return state;
  }
}
